import { render, staticRenderFns } from "./EditorSender.vue?vue&type=template&id=5579d628&scoped=true"
import script from "./EditorSender.vue?vue&type=script&lang=js"
export * from "./EditorSender.vue?vue&type=script&lang=js"
import style0 from "./EditorSender.vue?vue&type=style&index=0&id=5579d628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579d628",
  null
  
)

export default component.exports